import { DefaultState } from 'store/types';

export const VIEW_LODGING_REQUESTS_DATA_REQUEST = 'VIEW_LODGING_REQUESTS_DATA_REQUEST';
export const VIEW_LODGING_REQUESTS_DATA_SUCCESS = 'VIEW_LODGING_REQUESTS_DATA_SUCCESS';
export const VIEW_LODGING_REQUESTS_DATA_FAILURE = 'VIEW_LODGING_REQUESTS_DATA_FAILURE';

export type LodgingRequestStatuses = 'Open' | 'Completed' | 'Canceled' | 'Draft' | 'Pending';

export interface ViewLodgingRequestData {
  address: string | null;
  gender: string;
  email: string;
  phoneNumber: string;
  guestId: string;
  guestName: string;
  id: string;
  locationId: string;
  lodgingNotes: string;
  lodgingTypes: string[];
  fromDate: string;
  toDate: string;
  roommates: string[];
  userFriendlyId: number;
  status: LodgingRequestStatuses;
  lodgingOptionId?: string;
  bookingId?: string;
  isFlagged: boolean;
  notesCount: number;
  reservationStatus: string;
  startTime: string;
  distance: number;
  bookingDistance?: number;
  talentAgentEmail: string;
  lodgingCost: string;
  datesScheduled: string;
  isValidPhoneNumber?: boolean;
  lodgingRequestUserId: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
}

export type ViewLodgingRequestState = DefaultState & {
  contents?: ViewLodgingRequestData;
};

interface ReadViewLodgingRequestDataRequest {
  type: typeof VIEW_LODGING_REQUESTS_DATA_REQUEST;
}

interface ReadViewLodgingRequestDataSuccess {
  type: typeof VIEW_LODGING_REQUESTS_DATA_SUCCESS,
  contents: ViewLodgingRequestData;
}

interface ReadViewLodgingRequestDataFailure {
  type: typeof VIEW_LODGING_REQUESTS_DATA_FAILURE;
}

export type ViewLodgingRequestActionTypes = ReadViewLodgingRequestDataRequest | ReadViewLodgingRequestDataSuccess | ReadViewLodgingRequestDataFailure;